<template>
    <BaseModal ref="baseModalRef" v-bind="childProps">
        <template #body>
            <div class="search-wrap">
              <div class="row">
                <div class="col-md-3">
                  <div class="mb-3">
                    <ElLabel name="영업기회ID">
                      <template #end="{id}">
                        <ElInput :id="id" v-model="optySearchParams.sales_id" @inputKeyupEnter="getOptyList"/>
                      </template>
                    </ElLabel>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <ElLabel name="End User">
                      <template #end="{id}">
                        <ElInput :id="id" v-model="optySearchParams.end_user_cmp_nm" @inputKeyupEnter="getOptyList"/>
                      </template>
                    </ElLabel>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <ElLabel name="매출처">
                      <template #end="{id}">
                        <ElInput :id="id" v-model="optySearchParams.sales_cmp_nm" @inputKeyupEnter="getOptyList"/>
                      </template>
                    </ElLabel>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <ElLabel name="매출세금계산서">
                      <template #end="{id}">
                        <div class="d-flex" :id="id">
                          <DatePicker
                            :selectDate="optySearchParams.tax_dt_s"
                            @return="r=>optySearchParams.tax_dt_s = r"
                          /> 
                          <span class="px-2 pt-1">~</span>
                          <DatePicker
                            :selectDate="optySearchParams.tax_dt_e"
                            :minDate="optySearchParams.tax_dt_s"
                            @return="r=>optySearchParams.tax_dt_e = r"
                          />
                        </div>
                      </template>
                    </ElLabel>
                    
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="" class="form-label">Stage</label>
                    <SelectCode
                      :cd_gr="'STG_CD'"
                      @return="r=>optySearchParams.stage_cd = r.cd_id"
                    />
                  </div>
                </div>
                                      
              </div>
            </div>
            <div class="search-detail-wrap"></div>
  
            <div class="text-end py-2">
              <ElButton type="search" @buttonClick='getOptyList()'>검색</ElButton>
            </div>
  

            <div class="table-responsive table-list">
              <DataTable
                v-model:selection="gridProps.selection" 
                v-bind="gridProps"
              >
              <template #empty>
                      <div>데이터가 존재하지 않습니다.</div>
                  </template>
                <Column
                  v-for="(opty,index) of gridProps.optyGridColumn"
                  v-bind="opty"
                  :key="index"
                  :style = "opty.style"
                  class='blank-div'
                >
                <template #body="{ data,field }"  > 
                  <span v-if="opty.field == 'outcome_sum'">{{ priceToString(data.outcome_sum) }}</span>
                  <span v-else-if="opty.field == 'income_sum'">{{ priceToString(data.income_sum) }}</span>
                  <span v-else-if="opty.field == 'gm_amt'">{{ priceToString(data.income_sum) }}</span>
                  <span v-else>{{ data[field] }}</span>
                </template>
                </Column>
              </DataTable>
            </div>
        </template>
    </BaseModal>

</template>

<script setup>
import BaseModal from '@/components/common/modal/BaseModal.vue';
import { reactive,ref,onBeforeMount } from 'vue';
import { useLoading } from '@/composable/Loading.js'
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import DatePicker from '@/components/common/DatePicker.vue'
import { salesOptyList} from '@/api/sales';
import SelectCode from '@/components/common/SelectCode.vue';

const { setIsLoading } = useLoading()
const baseModalRef = ref()
const emits = defineEmits(['return'])

onBeforeMount(async()=>{
    await getOptyList()
})

//모달 속성
const childProps = ref({
    modalId : 'wOptyModal',
    modalNm : 'Warranty 영업기회 매핑',
    size:'xl',
    btnList : [
        {name : '선택' , classNm : 'search', function : selectData}
    ]
})

//검색 조건
const optySearchParams = reactive({
    sales_id : '',
    end_user_cmp_nm : '',
    sales_cmp_nm : '',
    tax_dt_s : '',
    tax_dt_e : '',
    stage_cd : '', 
    tax_ck : null
})

//그리드 속성값 정의
const gridProps = reactive({
    value : [],
    selection : null,
    optyGridColumn : [
        { header: "영업기회ID", field: "sales_id"},
        { header: "End User", field: "end_user_cmp_nm"},
        { header: "매출처", field: "sales_cmp_nm" },
        { header: "영업기회명", field: "sales_nm" },
        { header: "담당자1", field: "manager1" },
        { header: "담당자2", field: "manager2" },
        { header: "제조사", field: "maker_cmp_nm" },
        { header: "Stage", field: "stage_nm" },
        { header: "Bridge(B) Risk(R)", field: "bnr_nm"},
        { header: "영업대표", field: "sales_ceo"},
        { header: "총매출금액", field: "outcome_sum",style:{textAlign : 'right'}},
        { header: "총매입금액", field: "income_sum",style:{textAlign : 'right'}},
        { header: "GM Amount", field: "gm_amt",style:{textAlign : 'right'}},
        { header: "GM%", field: "gm_amt_per",style:{textAlign : 'right'}},
    ],
    dataKey : 'index',
    paginator : true,
    selectionMode : 'single',
    scrollable : true,
    rowsPerPageOptions : [10, 20, 50, 100, 200],
    rows : 10
})



function openModal(){
    baseModalRef.value.openModal()
}

function closeModal(){
    baseModalRef.value.closeModal()
}

//영업기회 조회
async function getOptyList(){
  try {
    setIsLoading(true)
    if(!optySearchParams.tax_dt_s && !optySearchParams.tax_dt_e){
      optySearchParams.tax_ck = null
    }else{
      optySearchParams.tax_ck = 1
    }

    let params = {...optySearchParams}
    params.tax_dt_s = params.tax_dt_s ? params.tax_dt_s.replaceAll('-','')  : ''
    params.tax_dt_e = params.tax_dt_e ? params.tax_dt_e.replaceAll('-','')  : ''
    const res = await salesOptyList(params)
    gridProps.value = [...res.rtn].map((item,index)=>{
      item.index = index
      return item
    })
  } catch (err) {
    console.error(err)
  }finally{
    setIsLoading(false)
  }
}

function getSummaryData(item){
    let summaryData = item.length > 5 ? item.slice(0,4)+" ..." : item;
    return summaryData
}

function priceToString(item) {
    return item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}




function selectData(){
    closeModal()
    emits('return',gridProps.selection)
    
}

defineExpose({
    openModal
})
</script>

<style scoped>
span{
  text-overflow: ellipsis;
}
</style>